enum ExceptionType {

    Form = 1,
}

export {ExceptionType};
